import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("estesia-lang") || "de");

  useEffect(() => {
    localStorage.setItem("estesia-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang] || translations.de;
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      return node;
    },
    [lang]
  );

  const tr = useCallback(
    (translationsObj) => {
      if (!translationsObj) return { title: "", description: "" };
      return translationsObj[lang] || translationsObj.de || Object.values(translationsObj)[0];
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tr }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
